/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const SORT_ORDER = {
  NONE: '',
  ASC: 'ASC',
  DSC: 'DSC',
};
